import React from "react";
import Select from "react-select";
import { ReconciledOption, ReconciledValue } from "./DownloadOptions/utils";

type Props = { onChange; options; value };
export const SelectWithBadge: React.FC<Props> = ({
  onChange,
  options,
  value,
}) => {
  return (
    <Select
      maxMenuHeight={600}
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      options={options}
      value={value}
      onChange={onChange}
      components={{
        Option: ReconciledOption,
        SingleValue: ReconciledValue,
      }}
    />
  );
};
export default SelectWithBadge;
